module.exports = __webpack_public_path__ + "img/no-results-search.5c0396b5.svg";